import TermsConditionModal from "./TermsConditionModal";

export default TermsConditionModal;
